import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';

import ToggleInput from '../inputs/ToggleInput';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicToggle extends Component {
    static propTypes = {
        className: PropTypes.string,
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        label: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        displayHelp: PropTypes.bool,
        description: PropTypes.string,
        styleProps: PropTypes.object,
        id: PropTypes.string,
        inputClassName: PropTypes.string
    };

    getGroupClassName = () => {
        const { required, className } = this.props;
        return cns(className, {
            required
        });
    };

    getFeedbackMessage = () => {
        const { touched, error, warning } = this.props.meta;
        let message = '';
        if (touched) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }
        return message;
    };

    getValidationState = () => {
        const { touched, error, warning } = this.props.meta;
        if (touched && error) {
            return 'error';
        }
        if (touched && warning) {
            return 'warning';
        }
        return null;
    };

    render() {
        const {
            label,
            description,
            input,
            meta,
            required = false,
            disabled = false,
            displayHelp = true,
            styleProps = {},
            id = null,
            inputClassName
        } = this.props;
        const { horizontal = false, labelClass } = styleProps;
        let labelSection = null;
        let helpBlockSection = null;

        if (label || description) {
            const labelSectionContainerClass = horizontal ? 'col-12 col-sm-6 no-padding' : null;
            labelSection = (
                <div className={labelClass || labelSectionContainerClass}>
                    <div className={horizontal ? 'col-12 col-sm-10 no-padding' : null}>
                        <label htmlFor={input.name} className={horizontal ? 'form-label' : null}>
                            {label}
                            {required && <span className={'required-tag'}>*</span>}
                        </label>
                        <p className={horizontal ? 'form-description' : null}> {description} </p>
                    </div>
                </div>
            );
        }

        if (displayHelp) {
            helpBlockSection = <FormText>{this.getFeedbackMessage()}</FormText>;
        }

        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                <ToggleInput
                    className={cns('basic-toggle')}
                    input={input}
                    meta={meta}
                    required={required}
                    id={id}
                    disabled={disabled}
                    inputClassName={inputClassName}
                />
                {helpBlockSection}
            </Form.Group>
        );
    }
}

export default WithTranslation(BasicToggle);
